<template>
<div>
	<v-layout>
		<v-flex md6 xs12>
			<v-layout v-if="!mobile">
				<v-select
					@click:clear="cleanSelectedType"
					v-model="selectedType"
					clearable
					:label="$t('workers.filters.type_label')"
					:items="filterTypes"
				>
					<template slot="selection" slot-scope="data">
						{{ $t('workers.filters.type_' + data.item) }}
					</template>
					<template slot="item" slot-scope="data">
						{{ $t('workers.filters.type_' + data.item) }}
					</template>
				</v-select>
			</v-layout>
			<v-layout>
				<v-select
					@click:clear="cleanSelectedType"
					v-if="selectedType == 'agency'"
					v-model="selectedAgency"
					clearable
					:label="$t('workers.filters.byAgency')"
					:items="agencyList"
					item-text="name"
					item-value="id"
					return-object
				/>
				<v-select
					@click:clear="cleanSelectedType"
					v-if="selectedType == 'employer'"
					v-model="selectedEmployer"
					clearable
					:label="$t('workers.filters.byEmployer')"
					:items="employerList"
					item-text="name"
					item-value="id"
					return-object
				/>
			</v-layout>
		</v-flex>
		<v-flex md6 xs12>
			<v-layout>
				<v-select
					@click:clear="cleanSelectedDateType"
					v-model="selectedDateType"
					clearable
					:label="$t('workers.filters.date_type_label')"
					:items="filterDateTypes"
				>
					<template slot="selection" slot-scope="data">
						{{ $t('workers.filters.type_' + data.item) }}
					</template>
					<template slot="item" slot-scope="data">
						{{ $t('workers.filters.type_' + data.item) }}
					</template>
				</v-select>
			</v-layout>
			<v-layout>
				<v-flex md11 v-if="selectedDateType == 'month'">
					<v-menu
						ref="dateMenuMonth"
						:close-on-content-click="false"
						v-model="dateMenuMonth"
						:nudge-right="40"
						:return-value.sync="dateMonth"
						lazy
						transition="scale-transition"
						offset-y
						full-width
						max-width="290px"
						min-width="290px"
					>
						<v-text-field
							slot="activator"
							v-model="selectedJobDateMonth"
							:label="$t('workers.filters.byDateMonth')"
							prepend-icon="event"
							readonly
							clearable
						/>
						<v-date-picker
							v-model="selectedJobDateMonth"
							type="month"
							locale="cs"
							:max="new Date().toISOString().substr(0, 10)"
							no-title
						/>
					</v-menu>
				</v-flex>
				<v-flex md6 v-if="selectedDateType == 'week'">
					<v-select
						v-model="selectedYear"
						clearable
						:label="$t('workers.filters.byDateYear')"
						:items="years"
					/>
				</v-flex>
				<v-flex md6 v-if="selectedDateType == 'week' && selectedYear">
					<v-select
						v-model="selectedJobDateWeek"
						clearable
						:label="$t('workers.filters.byDateWeek')"
						:items="weeks"
					/>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import moment from 'moment'

export default {
	props: [
		'agency',
		'employer',
		'jobDateMonth',
		'jobDateWeek',
	],
	data: vm => ({
		selectedType: null,
		filterTypes: ['employer', 'agency'],
		selectedDateType: null,
		filterDateTypes: ['month', 'week'],
		dateMenuMonth: null,
		dateMonth: null,
		mobile: false,
		weeks: [],
		selectedYear: null,
		filterTypeflag: false,
		filterDateTypeflag: false
	}),
	computed: {
		...mapState({
			workers: ({ workers }) => workers.workers,
		}),
		employerList() {
			return this.$store.state.employers.list
		},
		agencyList() {
			return [
				{
					id: 0,
					name: this.$t('agencies.notAgency')
				},
				...this.$store.state.agencies.agencies,
			]
		},
		selectedAgency: {
			get() {
				return this.agency
			},
			set(value) {
				this.$emit('changeSelectedAgency', value)
			}
		},
		selectedEmployer: {
			get() {
				return this.employer
			},
			set(value) {
				this.$emit('changeSelectedEmployer', value)
			}
		},
		selectedJobDateMonth: {
			get() {
				return this.jobDateMonth
			},
			set(value) {
				this.dateMenuMonth = false
				this.$emit('changeJobDateMonth', value)
			}
		},
		selectedJobDateWeek: {
			get() {
				return this.jobDateWeek ? parseInt(this.jobDateWeek.split('-')[1]) : null
			},
			set(value) {
				this.$emit('changeJobDateWeek', value ? this.selectedYear + '-' + value : null)
			}
		},
		years () {
			const year = new Date().getFullYear()
			return Array.from({length: year - 2000}, (value, index) => 2001 + index)
		}
	},
	created() {
		if(screen.width < 640) {
			this.mobile = true
			this.selectedType = 'employer'
		}
		let query = this.$route.query
		if(query.agency_id) {
			this.selectedType = 'agency'
		}
		if(query.employer_id) {
			this.selectedType = 'employer'
		}
		if(query.jobDateMonth) {
			this.selectedDateType = 'month'
		}
		if(query.jobDateWeek) {
			this.selectedDateType = 'week'
			this.selectedYear = parseInt(query.jobDateWeek.split('-')[0])
			this.selectedJobDateWeek = parseInt(query.jobDateWeek.split('-')[1])
		}
	},
	methods: {
		...mapActions({
			fetchAgencies: 'agencies/fetch',
			fetchEmployers: 'employers/fetch'
		}),
		getWeeks(year) {
			let weekNumbers = moment(year + '-12-28').format('W')
			return Array.from({length: weekNumbers}, (v, k) => k+1);
		},
		cleanSelectedType() {
			let query = Object.assign({}, this.$route.query)
			delete query.agency_id
			delete query.employer_id
			this.$router.replace({ query })

			this.selectedAgency = null
			this.selectedEmployer = null
		},
		cleanSelectedDateType() {
			let query = Object.assign({}, this.$route.query)
			delete query.jobDateMonth
			delete query.jobDateWeek
			this.$router.replace({ query })

			this.selectedJobDateMonth = null
			this.selectedJobDateWeek = null
		}
	},
	watch: {
		selectedType() {
			if(this.selectedType == 'employer') {
				this.fetchEmployers({
					count: 1000
				})
			} else if(this.selectedType == 'agency') {
				this.fetchAgencies({
					count: 1000
				})
			}
			if(this.filterTypeflag && this.selectedType != null) {
				this.cleanSelectedType()
			}
			this.filterTypeflag = true
		},
		selectedDateType() {
			if(this.filterDateTypeflag && this.selectedDateType != null) {
				this.cleanSelectedDateType()
			}
			this.filterDateTypeflag = true
		},
		selectedYear() {
			if(this.weeks.length > 0) {
				this.selectedJobDateWeek = null
			}
			this.weeks = this.getWeeks(this.selectedYear)
		}
	}
}
</script>

<style>

</style>
